<template>
  <div class="container-fluid marketing">
    <div class="row">
      <div v-for="category in categories.listIcons" class="col-10 col-sm-8 col-md-4 category-icon">
        <div class="category-top">
          <img
            class="category-image"
            :src="category.imageList[0]"
            alt="Generic placeholder image"
            width="140"
            height="140"
          />
        </div>
        <div class="category-bottom">
          <h5 class="category-name">{{category.name}}</h5>
          <p>
            <a
              class="category-button"
              href="#"
              role="button"
              @click="selected(category)"
            >Wybierz &raquo;</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      categories: state => state.categories
    })
  },
  methods: {
    selected(category) {
      this.$store.dispatch("categories/selected", {top: false, category: category});
      this.$emit("selected");
      this.$router.replace({ name: "searchPage" });
    }
  },
  beforeMount() {
    this.$store.dispatch("categories/requestData");
  }
};
</script>




// WEBPACK FOOTER //
// src/components/categories/src/CategoriesIconsWelcome.vue